<template>
    <v-layout class="px-3" row wrap>
        <confirmation-header-text class="ml-2" icon="mdi-account-multiple"
                                  text="Transit Visa"></confirmation-header-text>
        <v-flex md3 xs6 v-if="application_data.address_street_no">
            <list-item-detail
                    :sub_title="application_data.address_street_no"
                    title="Street number"/>
        </v-flex>
        <v-flex md3 xs6 v-if="application_data.street_name">
            <list-item-detail
                    :sub_title="application_data.street_name"
                    title="Street Name"/>
        </v-flex>

        <v-flex md3 xs6 v-if="application_data.street_no">
            <list-item-detail
                    :sub_title="application_data.street_no"
                    title="Street number"/>
        </v-flex>

        <v-flex md3 xs6 v-if="application_data.pin_number">
            <list-item-detail
                    :sub_title="application_data.pin_number"
                    title="PIN number"/>
        </v-flex>

    </v-layout>
</template>

<script>
    import ListItemDetail from "../../ListItemDetail";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";

    export default {
        components: {ListItemDetail, ConfirmationHeaderText},
        computed: {
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            },
        },
    };
</script>
